export const users = {
  "198ad60e415c4e358b0dd3c71a0a53d3": {
    id: "198ad60e415c4e358b0dd3c71a0a53d3",
    currencies: ["USD"],
    login: "gr8-iframe-demo-user-bra",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "BRA",
    userName: 'joao_oliveira97',
  },
  "842f6683cf5f45c4842c361619b96ea8": {
    id: "842f6683cf5f45c4842c361619b96ea8",
    currencies: ["USD"],
    login: "gr8-iframe-demo-user-ksa",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "KSA",
    userName: 'noura_almz',
  },
  "d75dab1922cf4a38a04544bac03a34ca": {
    id: "d75dab1922cf4a38a04544bac03a34ca",
    currencies: ["USD"],
    login: "gr8-iframe-demo-user-rsa",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "RSA",
    userName: 'lerato_sa',
  },
  "0362d26794804e7a883e06de80805dcd": {
    id: "0362d26794804e7a883e06de80805dcd",
    currencies: ["USD"],
    login: "gr8-iframe-demo-user-tur",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "TUR",
    userName: 'mehmet_aydn',
  },
  "95fb0dab74f64464bb779414118af791": {
    id: "95fb0dab74f64464bb779414118af791",
    currencies: ["USD"],
    login: "gr8-iframe-demo-user-ind",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "IND",
    userName: 'jaydenkoh',
  },
  "1cc970f2652345068ab4caefc52b5203": {
    id: "1cc970f2652345068ab4caefc52b5203",
    currencies: ["USD", "EUR", "XTS", "BTC", "ETH", "SOL"],
    login: "gr8-iframe-demo-user",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "GBR",
    userName: 'emily_b91',
  },
  "680b22aeb5f64d36bd8bbdb1566f928a": {
    id: "680b22aeb5f64d36bd8bbdb1566f928a",
    currencies: ["USD"],
    login: "gr8-iframe-demo-user-vnm",
    password: "gr8-tech",
    operatorId: "GR8SPORT",
    brand: "DEMODFLT",
    country: "VNM",
    userName: 'harryb_luxe',
  },
};
